<template>
  <div class="setting">
    <el-form
      :inline="true"
      label-position="left"
      label-width="100px"
      class="select-form"
      @submit.native.prevent
    >
      <el-form-item label="红包总量排序">
        <el-select v-model="search.sort" style="width: 100px" size="small">
          <el-option label="全部" value=""></el-option>
          <el-option label="升序" value="1"></el-option>
          <el-option label="降序" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户名称">
        <el-input
          v-model="search.username"
          size="small"
          placeholder="请输入分享人名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="搜索时间段">
        <el-date-picker
          size="small"
          v-model="search.timer"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-button type="primary" @click="queryRankData">查询</el-button>
    </el-form>

    <el-table :data="tableData" stripe style="width: 100%" border>
      <el-table-column
        align="center"
        prop="avatarUrl"
        label="用户头像"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="nickname"
        label="用户名称"
      ></el-table-column>
      <el-table-column prop="redpage_first" label="一级红包数"> </el-table-column>
      <el-table-column prop="redpage_second" label="二级红包数"> </el-table-column>
      <el-table-column prop="redpage_total" label="红包总数"> </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination background layout="prev, pager, next" :total="1000">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import RankApi from "@/api/rank.js";
export default {
  data() {
    return {
      search: {
        sort: "",
        username: "",
        timer: [],
      },
      form: "",
      tableData: [],
    };
  },
  components: {},
  created() {
    let params = { sort: "", username: "", timer: "" };
    this.queryRankData(params);
  },
  methods: {
    queryRankData(params) {
      RankApi.queryRank(params, false).then((res) => {
        this.tableData = res.data.data;
        console.log(this.tableData)
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/plus/rank/commission.vue